import React from 'react';
import { Link } from 'react-router-dom';

import { Avatar } from '@mui/material';

import ProtectedData from 'pages/components/ProtectedData';
import Utils from 'utils/Utils';

import useStyles from './styles';

interface Props {
    type: string;
    className?: string;
}

const Published: React.FC<Props> = ({ type, className }) => {
    const { classes, cx } = useStyles();

    return (
        <span className={cx(classes.container, className)}>
            <span className={classes.secondary}>{'Type'}</span>
            &nbsp;
            <ProtectedData data={type} rounded>
                {({ isProtected, content }) =>
                    isProtected ? (
                        <span className={classes.primary}>{content}</span>
                    ) : (
                        <>
                            <Avatar src={Utils.getImage(content)} alt={content} className={classes.image} />
                            &nbsp;
                            <Link to={`/search?query=type:${content}`} className={classes.primary} target="_blank">
                                {content}
                            </Link>
                        </>
                    )
                }
            </ProtectedData>
        </span>
    );
};

export default Published;
